<template>
  <div class="ar-matches-container">
    <div class="ar-matches-list" ref="scrollContainer">
      <div
        v-for="(value, key) in arMatches"
        :key="`ar-item-${key}`"
        class="ar-match-item"
        :ref="`item-${key}`"
      >
        <div class="spinner-container" v-if="value == '' || value == null">
          <b-spinner variant="primary" class="loading-spinner"></b-spinner>
        </div>
        <ar-data
          v-else-if="value && typeof value === 'object'"
          :key="`ar-data-${key}-${value.created_at || key}`"
          :dataMatch="value"
          :index="key"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ARData from "./ARData.vue";
import axios from "@axios";
import { BButton } from "bootstrap-vue";

export default {
  components: { "ar-data": ARData, BButton },
  props: { data: Object, totalMatches: Number },
  data() {
    return {
      arMatches: [],
      observer: null,
      loadedItems: new Set(),
    };
  },
  methods: {
    showMessage(title, msg, variant = "success") {
      this.$toast({
        component: ToastificationContent,
        position: "top-right",
        props: { title, variant, icon: "BellIcon", text: msg, timeout: 5000 },
      });
    },
    async loadARMatch(index) {
      if (this.loadedItems.has(index) || (this.arMatches[index] !== '' && this.arMatches[index] !== null)) return;

      this.loadedItems.add(index);

      try {
        const response = await axios.post(`${window.__env.VUE_APP_BASE_URL}/v1/analytic/analyticRecordByIndex`, {
          alarmId: this.$props.data.id_alarm,
          index: index,
        });
        const arMatch = response.data.data;
        this.$set(this.arMatches, index, arMatch);
      } catch (error) {
        console.error("Error loading AR match:", error);
        this.loadedItems.delete(index);
        this.$set(this.arMatches, index, null);
      }
    },
    setupIntersectionObserver() {
      if (!('IntersectionObserver' in window)) {
        for (let i = 1; i < this.arMatches.length; i++) {
          this.loadARMatch(i);
        }
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index);
            if (!isNaN(index)) {
              this.loadARMatch(index);
            }
          }
        });
      }, {
        root: this.$refs.scrollContainer,
        rootMargin: '100px',
        threshold: 0.1
      });

      this.$nextTick(() => {
        for (let i = 1; i < this.arMatches.length; i++) {
          const element = this.$refs[`item-${i}`];
          if (element && element[0]) {
            element[0].dataset.index = i;
            this.observer.observe(element[0]);
          }
        }
      });
    },
  },
  async mounted() {
    const totalMatches = this.$props.totalMatches;

    for (let i = 0; i < totalMatches; i++) {
      this.$set(this.arMatches, i, "");
    }

    this.$set(this.arMatches, 0, this.$props.data);
    this.loadedItems.add(0);

    if (this.$props.data && totalMatches > 0) {
      this.$emit("has-ar-data", true);

      // Configurar lazy loading para el resto
      if (totalMatches > 1) {
        this.setupIntersectionObserver();
      }
    }
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>

<style scoped>
.ar-matches-container {
  width: 100%;
}

.ar-matches-list {
  max-height: 400px;
  overflow-y: auto;
}

.ar-match-item {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.ar-match-item:last-child {
  margin-bottom: 0;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}

.loading-spinner {
  margin-top: 20px;
}

.dark-layout .ar-match-item {
  background-color: var(--main-dark);
}
</style>
